<template>
  <div id="top-five" class="wrapper">
    <div class="container">
      <h5 class="title">Your top {{ domains_count }} domains</h5>

      <table>
        <!--   The col element control the width of the col in mobile     -->
        <col class="hide-in-desktop" style="width: 60%">
        <col class="hide-in-desktop" style="width: 20%">
        <col class="hide-in-desktop" style="width: 20%">

        <thead>
          <tr>
            <th v-for="col in formColumns" class="columns" :key="col">{{ col }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="domain of get_domains_ordered " class="domain" :key="domain.Address" @click="handleDomainSelect(domain)">
            <td class="address" v-text="domain.Address" />
            <td class="budget">{{ budgetWasted( domain.PotentialSaving, domain.Currency ) }}</td>
            <td class="bar">
              <linear-progress :value="protectionScore( domain.ProtectionScore )" text-size="20" class="linear-progress-mobile"/>
            </td>
            <td class="arrow"><img src="@/assets/images/icons/arrow_right.svg" alt="arrow right"></td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { currencyAndSymbol, formatScore } from "@/utils";
import LinearProgress from "@/components/global/progress/Linear";

export default {
  name: "Top5Domains",
  components: {
    LinearProgress,
  },
  data() {
    return {
      formColumns: ['Domain name', 'Budget wasted', 'Protection score'],
    };
  },
  computed: {
    ...mapGetters(['get_domains']),

    domains_count() {
      return this.get_domains.length;
    },

    get_domains_ordered() {
      return this.get_domains.sort((a,b) => b.PotentialSaving - a.PotentialSaving);
    },
  },
  methods: {
    ...mapMutations(['SET_SELECTED_DOMAIN']),

    budgetWasted(amount, currency) {
      return currencyAndSymbol(amount, currency, true);
    },

    protectionScore(score) {
      return formatScore(score);
    },

    handleDomainSelect(domain) {
      this.SET_SELECTED_DOMAIN(domain);
      this.$router.push({ name: 'Report 2 Selected' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/style/colors";
@import "src/assets/style/responsive";

#top-five {
  padding-top: 60px;
  padding-bottom: 80px;

  .wrapper {
    background: white;
  }

  .title {
    font-size: 28px;
    margin-top: 0;
    margin-bottom: 56px;
  }

  table {
    text-align: left;
    width: 100%;
    max-width: 860px;
    margin: 0 auto;

    @include mobile {
      table-layout: fixed;
    }
    tr {
      display: table-row;

      &:first-child > * {
        padding-bottom: 16px;
      }
      &:not(:first-child) > * {
        padding-top: 28px;
        padding-bottom: 28px;

        @include mobile {
          padding: 16px 0;
        }
      }
      &:not(:last-child) {
        border-bottom: 1px solid #E9E8E8;
      }
    }
    .columns {
      font-weight: bold;
      font-size: 20px;

      @include mobile {
        font-size: 14px;
      }
    }
    .domain {
      cursor: pointer;

      .address {
        display: inline-block;
        max-width: 95%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        img {
          @include mobile {
            width: 16px;
            height: 16px;
          }
        }
      }
    .budget {}
    .bar {}
      .arrow {
        width: 60px;
        @include mobile {
          width: min-content;
        }
        img {
          @include mobile {
            width: 10px;
            height: 8px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import "src/assets/style/responsive";

#top-five {
  @include mobile {
    .linear-progress-mobile {
      justify-content: flex-end;
      margin-right: 6px;

      .bar {
        width: 8px;
        height: 8px;

        .progress {
          width: 100% !important;
        }
      }
      span {
        font-size: 16px !important;
        margin-left: 6px !important;
      }
    }
  }
}
</style>